export default {
  title: 'Unavailable on educational',
  body: 'You\'re on the educational version of athlisis, which doesn\'t include this feature. Upgrade to full athlisis to unlock it along with all premium capabilities.',
  titlePromo: 'Unlock full athlisis',
  bodyPromo: 'You\'re on the educational version. Upgrade with your unique student discount and get all premium features.',
  bodyOffline: 'This feature is not available in the offline edition of athlisis.',
  offerLabel: 'Student offer',
  offerNote: 'Just for you, thanks to your school — with up to 3 instalments.',
  autoApplied: 'The discount is applied automatically at checkout.',
  ctaPurchase: 'Upgrade now',
  unavailable: 'Unavailable on educational',
}
